export { default as TableFooter } from './TableFooter';
